import { connect } from 'react-redux';
import { selectDesktopNavIsCollapsed } from 'features/Sidenav/selectors';
import SaveBar from './SaveBar';

export const mapStateToProps = state => ({
  desktopNavIsCollapsed: selectDesktopNavIsCollapsed(state),
});

export default connect(mapStateToProps)(SaveBar);
